import { IntlProvider } from 'app/shared/providers/intl-provider';
import { AppRouter } from 'app/components/router';
import { BrowserRouter } from 'react-router';
import { ApiProvider } from 'app/shared/contexts/api';
import { BuildingProvider } from 'app/shared/contexts/building';
import { ErrorBoundary } from 'react-error-boundary';
import { UserProvider } from 'app/shared/contexts/user';
import { LaunchDarklyProvider } from 'app/shared/providers/launch-darkly';
import { ThemeProvider } from 'app/shared/contexts/theme';
import { MiniappSdkProvider } from 'app/shared/contexts/miniapp-sdk';
import { ActivityPaneProvider } from 'app/shared/contexts/activity-pane';
import { AuthTokenSync } from 'app/shared/hooks/use-auth-token-sync';
import { BookingActivityStream } from 'app/shared/hooks/use-booking-activity-stream';
import { SdkCapabilitiesProvider } from 'app/shared/contexts/sdk-capabilities';
import { HostInfoProvider } from 'app/shared/contexts/host-info';
import { QueryClientProvider } from 'app/shared/providers/query-client-provider';
import { Skeleton } from '@hqo/ui-atoms';
import { ErrorsProvider } from 'app/shared/contexts/errors';
import { captureException } from './shared/sentry/sentry.utils';
import '../index.css';

export const App = (): JSX.Element => (
  <ErrorBoundary onError={captureException} fallback={<Skeleton className="w-full h-full" />}>
    <ErrorsProvider>
      <QueryClientProvider>
        <BrowserRouter>
          <ApiProvider>
            <MiniappSdkProvider>
              <SdkCapabilitiesProvider>
                <HostInfoProvider>
                  <AuthTokenSync />
                  <UserProvider>
                    <BookingActivityStream />
                    <IntlProvider>
                      <BuildingProvider>
                        <ThemeProvider>
                          <LaunchDarklyProvider>
                            <ActivityPaneProvider>
                              <AppRouter />
                            </ActivityPaneProvider>
                          </LaunchDarklyProvider>
                        </ThemeProvider>
                      </BuildingProvider>
                    </IntlProvider>
                  </UserProvider>
                </HostInfoProvider>
              </SdkCapabilitiesProvider>
            </MiniappSdkProvider>
          </ApiProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorsProvider>
  </ErrorBoundary>
);
